//Table sort function se basa OLYB2B-633
/**
 * Para ordenar debemos convertor los valores.
 * Available types: Date, Number, String, None or Empty String
 * 
 * 
 * @param {*} object con las propiedades
 * @param {*} property propiedad a convertir
 * @param {*} type tipo de dato a generar
 */
function getValueConverted(object, property, type) {
    if(property.includes('.')) {
        property = property.split('.')[1];
    }
    switch (type) {
    case 'Date':
        //No me gusta MOMENT porque es re mem.consumer. Siempre los primitivos son mas rapidos.
        //return moment(object[property], 'DD/MM/YYYY').toDate();
        return new Date(object[property].replace( /(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'));
    case 'Number':
        return Number(object[property]);
    case 'String':
    default:
        return object[property].toUpperCase();
    }
}
/**
 * Si la propiedad a pedir tiene un punto. Necesitamos descender en el objecto anidado.
 * 
 * @param {*} source Object
 * @param {*} props prop1.subprop2
 */
function getObject(source, props) {
    if(props.includes('.')) {
        return source[props.split('.')[0]];
    }
    return source;
}

/**
 * Table sortFunction
 * ordena data un array de objecto.
 * segun el orden ASC|DESC
 * tomando la definicion de la columna.
 * 
 */
export const tableSortFunction = (data, order, colDef) => {
    const sortType = colDef.sortType;
    if(sortType === 'NoSort'){
        return data;
    }
    //si no me pasan columnName para ordernar devuelvo la collection.
    if(!colDef.id) {
        return data;
    }
    return data ?
        data.sort((a, b) => {
            a = getObject(a, colDef.id);
            b = getObject(b, colDef.id);
            if(a && b) {
                return order.toUpperCase() === 'DESC' ?
                    (getValueConverted(b, colDef.id, sortType) < getValueConverted(a, colDef.id, sortType)  ? -1 : 1) : 
                    (getValueConverted(a, colDef.id, sortType) < getValueConverted(b, colDef.id, sortType) ? -1 : 1)
                ;
            } else {
                return 1;
            }
        })
        :[];
};


// WEBPACK FOOTER //
// ./src/components/Utils/tableSortFunction.js